import { render, staticRenderFns } from "./RosterSvg.vue?vue&type=template&id=4afa3506&"
import script from "./RosterSvg.vue?vue&type=script&lang=ts&"
export * from "./RosterSvg.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports